export default "__VITE_ASSET__D0X6KXge__"